import { render, staticRenderFns } from "./HomeEmbed.vue?vue&type=template&id=94ed9f8c"
import script from "./HomeEmbed.vue?vue&type=script&lang=js"
export * from "./HomeEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports